import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { GrupoMotivoPerda } from 'src/app/models/grupo-motivo-perda';
import { MotivoPerda } from 'src/app/models/motivo-perda';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GrupoMotivoPerdaService } from 'src/app/services/grupo-motivo-perda.service';
import { MotivoPerdaService } from 'src/app/services/motivo-perda.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-motivo-perda-orc-modal',
  templateUrl: './motivo-perda-orc-modal.component.html',
  styleUrls: ['./motivo-perda-orc-modal.component.scss']
})
export class MotivoPerdaOrcModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  motivoSelecionado: number;
  motivosPerda: MotivoPerda[] = [];
  texto= 'Pedido';
  grupos: GrupoMotivoPerda[] = [];
  grupoSelecionado;

  constructor(public dialogRef: MatDialogRef<MotivoPerdaOrcModalComponent>, private motivoPerdaService: MotivoPerdaService,
    @Inject(MAT_DIALOG_DATA) public data: any, private carregandoService: CarregandoService, private notificacaoService: NotificacaoService,
    private gruposMotivoPerdaService: GrupoMotivoPerdaService) {
    this.texto = data.texto;
  }

  ngOnInit() {
    this.buscarMotivos();
    this.buscarGruposMotivoPerda();
  }

  salvar() {
    this.dialogRef.close(this.motivoSelecionado);
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarMotivos() {
    this.carregandoService.mostra('buscarMotivos');
    this.motivoPerdaService.consultar(this.grupoSelecionado).subscribe(m => {
      this.motivosPerda = m;
      this.carregandoService.esconde('buscarMotivos');
    }, (erro) => {
      this.carregandoService.esconde('buscarMotivos');
      this.notificacaoService.erro(erro);
    });
  }

  buscarGruposMotivoPerda() {
    this.carregandoService.mostra('buscaGrupos');
    this.gruposMotivoPerdaService.buscarTodos().subscribe(data => {
      this.grupos = data;
      this.carregandoService.esconde('buscaGrupos');
    }, (erro) => {
      this.notificacaoService.erro('Não foi possível buscar os grupos');
      this.carregandoService.esconde('buscaGrupos');
    });
  }
}
